<template>
  <div class="upload_wrap">
    <el-upload v-if="!isDisabled" class="upload-demo" :action="uploadUrl+action" :limit="limit" :show-file-list="false" :on-exceed="handleExceed" :on-success="uploadSuccess" :before-upload="beforeUpload">
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
    <div class="file_all" v-if="list.length>0">
      <div class="file_box" v-for="(item,index) in list" :key="item.id" @click="downloadFile(item.id)">
        <p>{{ item.name }}</p>
        <el-popconfirm v-if="!isDisabled" title="确定删除吗？" @confirm="closeFileFn(index)">
          <i class="close_btn el-icon-error" slot="reference" style="font-size: 20px; color: red"></i>
        </el-popconfirm>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    //  文件列表
    filelist: {
      type: Array,
      default() {
        return []
      },
    },
    // 文件个数
    limit: {
      type: [Number, String],
      default: 10,
    },
    action: {
      type: String,
      default: "/upload/uploadToLocal",
    },
    isDisabled: {//是否禁用
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      list: this.filelist,
      quillUpdate: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      fileFormList: [],
    };
  },
  watch: {
    filelist: function (val) {
      this.list = val;
      // console.log('相关资料文件',val);
    },
    // list: function (val) {
    //   console.log(val);
    //   this.$emit("file-event", val);
    // },
  },
  methods: {
    downloadFile(id) {
      window.open(`${this.uploadUrl}/upload/download?id=${id}&openStyle=1`, '_blank');
    },
    beforeUpload(file) {
      const isNeedFileType = file.type !== 'application/x-msdownload' && file.type !== '';
      const isLt300M = file.size / 1024 / 1024 < 300;

      if (!isNeedFileType) {
        this.$message.error('上传文件不能是exe，bat，cmd，vbs，dll格式!');
      }
      if (!isLt300M) {
        this.$message.error('上传文件大小不能超过 300MB!');
      }
      return isNeedFileType && isLt300M;
    },
    // 删除文件
    closeFileFn(index) {
      this.list.splice(index, 1);
      this.$emit("file-event", this.list);
    },
    // 文件数量限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择${this.limit} 个文件，本次选择了 
        ${files.length} 
        个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 上传文件成功后
    uploadSuccess(res, file, fileList) {
      console.log("上传成功", res, file, fileList);
      this.list.push({
        id: res.data[0],
        name: file.name,
      });
      this.$emit("file-event", this.list);
    },
  },
};
</script> 

<style scoped>
.file_box {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px dashed #d9d9d9;
  height: 30px;
  padding: 0 20px;
  cursor: pointer;
  max-width: calc(100% - 150px);
  margin: 5px 0;
}
.file_box p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 450px;
  margin-bottom: 0;
  line-height: normal;
}
.close_btn {
  position: absolute;
  top: -8px;
  right: -8px;
}
.upload_wrap >>> .avatar-uploader .el-upload {
  border-radius: 0;
  border: none;
  cursor: pointer;
  overflow: inherit;
  width: auto;
  height: 32px;
  max-width: 100%;
}
</style>